// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e387fe15","732":"cf27b275","977":"14ab8d14"}[chunkId] + ".chunk.js";
};